"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _decorators = require("decorators");

var _animationHelper = require("animation-helper");

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var BasicBanner = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(BasicBanner, _Block);

  function BasicBanner() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, BasicBanner);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(BasicBanner)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "headerContent", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "summary", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "summaryElement", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "button", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "image", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(BasicBanner, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "text-container"
      }, _react.default.createElement("h2", {
        className: "header-text"
      }, this.headerContent), _react.default.createElement(this.summaryElement, this.summary), this.button && _react.default.createElement(Button, this.button)), this.image && _react.default.createElement("div", {
        className: "image-container",
        style: {
          backgroundImage: "url(".concat(this.image, ")")
        }
      }));
    }
  }]);
  return BasicBanner;
}(_base.default), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "headerContent", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "summaryElement", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "button", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = BasicBanner;
var Button = (_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(Button, _React$Component);

  function Button() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Button)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "attributes", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "scrollTarget", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(Button, [{
    key: "scrollIntoView",
    value: function scrollIntoView(event) {
      event.preventDefault();
      (0, _animationHelper.animateToSelector)("[data-block-id=\"".concat(this.scrollTarget, "\"]"));
    }
  }, {
    key: "render",
    value: function render() {
      var extra = {};

      if (this.scrollTarget) {
        extra.href = 'javascript:void(0)';
        extra.onClick = this.scrollIntoView;
      }

      return _react.default.createElement("a", _extends({}, this.attributes, extra), this.children);
    }
  }]);
  return Button;
}(_react.default.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "attributes", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "scrollTarget", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "scrollIntoView", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "scrollIntoView"), _class.prototype)), _class);